import { FC, MouseEvent } from "react";
import {
    ModifiedStyledLink,
    StyledLinkContainer,
    StyledLinks,
    StyledLinkWrapper,
    StyledSeparator,
} from "../styledComponents";
import { TruncateWithTooltip } from "@kaltura/mediaspace-shared-ui";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

export enum Content {
    URL = "URL",
    Script = "Script",
}
export type LinkType = keyof typeof Content;

export type TextAndLink = {
    sectionType: LinkType;
    sectionText?: string;
    sectionLink: string;
};

interface TextAndLinksProps {
    items?: TextAndLink[];
    linkSeparator?: string;
    classes?: Partial<Record<"linkWrapper" | "separator" | "link", string>>;
}

const TextAndLinks: FC<TextAndLinksProps> = ({ items, linkSeparator, classes }) => {
    const sendButtonAnalytics = useButtonAnalytics();

    const sendAnalytics = (actionName: string) => {
        sendButtonAnalytics(actionName, ButtonClickAnalyticsType.LAUNCH);
    };
    return (
        <StyledLinks>
            {items?.map((textAndLink, index) => {
                if (textAndLink.sectionLink.length > 0) {
                    switch (textAndLink.sectionType) {
                        case "Script":
                            return (
                                <StyledLinkWrapper key={index} className={classes?.linkWrapper}>
                                    {index > 0 && (
                                        <StyledSeparator className={classes?.separator}>
                                            {linkSeparator}
                                        </StyledSeparator>
                                    )}
                                    <StyledLinkContainer>
                                        <TruncateWithTooltip text={textAndLink.sectionText}>
                                            <ModifiedStyledLink
                                                className={classes?.link}
                                                onClick={() => {
                                                    eval(textAndLink.sectionLink);
                                                    sendAnalytics("Footer - Links - JS");
                                                }}
                                                component={"button"}
                                                variant={"body2"}
                                                aria-label={textAndLink.sectionText}
                                                translucent={true}
                                            >
                                                {textAndLink.sectionText}
                                            </ModifiedStyledLink>
                                        </TruncateWithTooltip>
                                    </StyledLinkContainer>
                                </StyledLinkWrapper>
                            );
                        case "URL":
                            return (
                                <StyledLinkWrapper key={index} className={classes?.linkWrapper}>
                                    {index > 0 && (
                                        <StyledSeparator className={classes?.separator}>
                                            {linkSeparator}
                                        </StyledSeparator>
                                    )}
                                    <StyledLinkContainer>
                                        <TruncateWithTooltip text={textAndLink.sectionText}>
                                            <ModifiedStyledLink
                                                className={classes?.link}
                                                href={textAndLink.sectionLink}
                                                target={"_blank"}
                                                rel={"noopener noreferrer"}
                                                onClick={() => {
                                                    sendAnalytics("Footer - Links - URL");
                                                }}
                                                aria-label={textAndLink.sectionText}
                                                translucent={true}
                                            >
                                                {textAndLink.sectionText}
                                            </ModifiedStyledLink>
                                        </TruncateWithTooltip>
                                    </StyledLinkContainer>
                                </StyledLinkWrapper>
                            );
                        default:
                            // never should happen
                            return null;
                    }
                }
                else {
                    return (
                        <StyledLinkWrapper key={index} className={classes?.linkWrapper}>
                            {index > 0 && (
                                <StyledSeparator className={classes?.separator}>{linkSeparator}</StyledSeparator>
                            )}
                            <StyledLinkContainer>
                                <TruncateWithTooltip text={textAndLink.sectionText}>
                                    <ModifiedStyledLink
                                        className={classes?.link}
                                        onClick={(e: MouseEvent<HTMLElement>) => e.preventDefault()}
                                        target={"_blank"}
                                        translucent={true}
                                    >
                                        {textAndLink.sectionText}
                                    </ModifiedStyledLink>
                                </TruncateWithTooltip>
                            </StyledLinkContainer>
                        </StyledLinkWrapper>
                    );
                }
            })}
        </StyledLinks>
    );
};

export default TextAndLinks;
